import axios from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

export default {
  login(user) {
    return apiClient.post("/login", user);
  },
  logout(user) {
    return apiClient.post("/logout", user);
  },
  getUsers() {
    return apiClient.get("/users");
  },
  getUser(id) {
    return apiClient.get("/users/" + id);
  },
  addUser(dataUser) {
    return apiClient.post("/signup", dataUser);
  },
  editUser(dataUser) {
    return apiClient.put("/users/edit", dataUser);
  },
  deleteUser(id) {
    return apiClient.delete("/users/delete/" + id);
  },
  updatePassword(data) {
    return apiClient.put("/users/updatePassword", data);
  },

  // ROLES
  selectRoles() {
    return apiClient.get("/selectroles");
  },

  getRoles() {
    return apiClient.get("/roles");
  },
  getRole(id) {
    return apiClient.get("/roles/" + id);
  },
  addRole(dataRole) {
    return apiClient.post("/roles/new", dataRole);
  },
  editRole(dataRole) {
    return apiClient.put("/roles/edit", dataRole);
  },
  deleteRole(id) {
    return apiClient.delete("/roles/delete/" + id);
  },
  //CEDULAS
  consultarCedula(data) {
    return apiClient.get("/cedulas", { params: data });
  },
  validarCedula(data) {
    return apiClient.post("/comprobar-cedulas", data );
  },
  reporteCedulas(data) {
    // return apiClient.get("/cedulas/reporte", { params: data });
    return apiClient.get("/cedulas/reporte/" + data);
  },
  mostrarCedula(id) {
    return apiClient.get("/cedula/" + id);
  },
  saveCedula(data) {
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    return apiClient.post("/cedula", data);
  },
  updateCedula(data) {
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    return apiClient.post("/cedula/update", data);
  },
  pdfCedula(id) {
    return apiClient.get("/generate-pdf/" + id, {
      responseType: "arraybuffer"
    });
  },

  pdfAcuse(data) {
    return apiClient.post("/comprobar-cedula-pdf", data,{
      responseType: "arraybuffer"
    });
  },
  sendPdf(id) {
    return apiClient.get("/cedula/" + id + "/send");
  },
  pdfRegistros(data) {
    return apiClient.get("/pdfRegistros/" + data.fecha_inicio, {
      responseType: "arraybuffer"
    });
  },

  getLogsPaginate(data) {
    return apiClient.get("/logs", { params: data });
  },

  getEstados(data) {
    return apiClient.get("/estados");
  },
  getMunicipios(estadoId) {
    return apiClient.get("/municipios/" + estadoId);
  },
  Amazon_Trust_Services() {
    return apiClient.get("/amazon-trust-services");
  }
};
